import { harvestYearDetail } from "../../config/harvestYearDetail";
import { globalApiHandler } from "../../services/services";
import { isAuthorized } from "../../components/Common/CheckAuthorization";

export const SUBFARM = {
  list: {
    success: "SUBFARM_LIST_SUCCESS",
    error: "SUBFARM_LIST_ERROR"
  },
  create: {
    success: "SUBFARM_CREATE_SUCCESS",
    error: "SUBFARM_CREATE_ERROR"
  },
  edit: {
    success: "SUBFARM_EDIT_SUCCESS",
    error: "SUBFARM_EDIT_ERROR"
  },
  update: {
    success: "SUBFARM_UPDATE_SUCCESS",
    error: "SUBFARM_UPDATED_ERROR"
  },
  delete: {
    success: "SUBFARM_DELETE_SUCCESS",
    error: "SUBFARM_DELETE_ERROR"
  }
};

export const MAINFARM = {
  list: {
    success: "MAINFARM_LIST_SUCCESS",
    error: "MAINFARM_LIST_ERROR"
  },
  create: {
    success: "MAINFARM_CREATE_SUCCESS",
    error: "MAINFARM_CREATE_ERROR"
  },
  edit: {
    success: "MAINFARM_EDIT_SUCCESS",
    error: "MAINFARM_EDIT_ERROR"
  },
  update: {
    success: "MAINFARM_UPDATE_SUCCESS",
    error: "MAINFARM_UPDATED_ERROR"
  },
  delete: {
    success: "MAINFARM_DELETE_SUCCESS",
    error: "MAINFARM_DELETE_ERROR"
  }
};

export const getAllFarmsList = (harvestYear = harvestYearDetail().name) => {
  let url = `/ntrac/farm`;
  return dispatch => {
    globalApiHandler(url, "get", {}, dispatch)
      .then(response => {
        const data = response.data.data;
        // let data = Object.keys(responseData).map(value => {
        //   responseData[value]["name"] = responseData[value].farmName;
        //   return responseData[value];
        // });
        data.map(item => {
          item.name = item.farmName;
          item.streetAddress = item.address.streetAddress;
          item.town = item.address.town;
          item.state = item.address.state;
          item.zipCode = item.address.zipCode;
          item.address = `${item.streetAddress} ${item.town} 
          ${item.state} ${item.zipCode}`;
        });
        isAuthorized() &&
          data.push({
            name: "Farm Management",
            id: "farmMgmtLink"
          });
        dispatch({ type: SUBFARM.list.success, data: data });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const createSubFarm = farmInfo => {
  let url = `/ntrac/farm`;
  return dispatch => {
    return globalApiHandler(url, "post", farmInfo)
      .then(response => {
        const data = response.data;
        dispatch({ type: SUBFARM.create.success, data });
        // dispatch({ type: "SERVER_SUCCESS", data: data });
        return data;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
        return err.data;
      });
  };
};

export const createSubFarmfSuperAdmin = farmInfo => {
  let url = `/ntrac/farm/${farmInfo.id}`;
  return dispatch => {
    return globalApiHandler(url, "post", farmInfo)
      .then(response => {
        const data = response.data;
        dispatch({ type: SUBFARM.create.success, data });
        dispatch({ type: "SERVER_SUCCESS", data: data });
        return data;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
        return err.data;
      });
  };
};

export const updateFarmId = subFramId => {
  return dispatch => {
    dispatch({ type: "SUB_FARM_ID", data: subFramId });
  };
};

export const farmEditAction = data => {
  return dispatch => {
    dispatch({ type: SUBFARM.edit.success, data });
  };
};

export const farmUpdateAction = farmInfo => {
  let url = `/ntrac/farm/${farmInfo.id}`;
  return dispatch => {
    globalApiHandler(url, "put", farmInfo)
      .then(response => {
        dispatch({ type: SUBFARM.update.success, data: response.data });
        dispatch({ type: "SERVER_SUCCESS", data: response.data });
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const getAllMainFarmsList = () => {
  let url = `/ntrac/farm/getMainFarmList`;
  return dispatch => {
    globalApiHandler(url, "get", {}, dispatch)
      .then(response => {
        const data = response.data.data;
        // let data = Object.keys(responseData).map(value => {
        //   responseData[value]["name"] = responseData[value].farmName;
        //   return responseData[value];
        // });
        data.map(item => {
          item.name = item.farmName;
          item.streetAddress = item.address.streetAddress;
          item.town = item.address.town;
          item.state = item.address.state;
          item.zipCode = item.address.zipCode;
          item.address = `${item.streetAddress} ${item.town} 
          ${item.state} ${item.zipCode}`;
        });
        dispatch({ type: MAINFARM.list.success, data: data });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};

export const updateMainFarmId = mainFramId => {
  return dispatch => {
    dispatch({ type: "MAIN_FARM_ID", data: mainFramId });
  };
};

export const getAllSubFarmsList = mainFarmId => {
  let url = `/ntrac/farm/getSubFarmList?farmId=${mainFarmId}`;
  return dispatch => {
    globalApiHandler(url, "get", {}, dispatch)
      .then(response => {
        const data = response.data.data || [];
        // let data = Object.keys(responseData).map(value => {
        //   responseData[value]["name"] = responseData[value].farmName;
        //   return responseData[value];
        // });

        data.map(item => {
          item.name = item.farmName;
          item.streetAddress = item.address.streetAddress;
          item.town = item.address.town;
          item.state = item.address.state;
          item.zipCode = item.address.zipCode;
          item.address = `${item.streetAddress} ${item.town} 
          ${item.state} ${item.zipCode}`;
        });
        isAuthorized() &&
          data.push({
            name: "Farm Management",
            id: "farmMgmtLink"
          });
        dispatch({ type: SUBFARM.list.success, data: data ? data : [] });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/farmManagement/action.js